/*
 * @Description:
 * @Date: 2020-10-14 15:58:13
 * @LastEditors: Please set LastEditors
 */

import fields from './fields';
import search from './search';
import TableRenderClass from '@/components/tableRender/tableRenderClass';

let example = new TableRenderClass({ fields, search });

const homePagePart = example.createPart({
  name: '结算汇总',
  search: ['projectId', 'taskDt', 'fullName', 'phone'],
  list: null,
  requestNow: true,
  fields: [
    'index',
    'fullName',
    'userPhone',
    'bankNo',
    'projectName',
    'taskDt',
    'supplierName',
    'finishSum',
    'taskPrice',
    'finishSumTaskPrice',
    'commission',
    'totalPrice',
    'payStatus',
    'finishPayDt',
    'endPointFinishPayDt'
  ]
});

export default { name: '订单详情', childMenu: [homePagePart] };
